document.addEventListener('click', (e) => {
  const swatch = e.target.closest('.sbc-card-swatch');
  if (!swatch) return;
  if (swatch.classList.contains('is-active')) { e.preventDefault(); return; }

  e.preventDefault();

  const card = swatch.closest('product-card');
  if (!card) return;

  const primaryImg   = card.querySelector('.product-card__image--primary');
  const secondaryImg = card.querySelector('.product-card__image--secondary');
  const mediaLink    = card.querySelector('.product-card__media-link');
  const titleLink    = card.querySelector('.product-card__title-link');
  const colorLabel   = card.querySelector('.sbc-card-color');
  const priceEl      = card.querySelector('.sbc-card-price');

  // Swap images
  if (primaryImg && swatch.dataset.primarySrc) {
    primaryImg.srcset = swatch.dataset.primarySrcset || '';
    primaryImg.src    = swatch.dataset.primarySrc;
  }
  if (secondaryImg) {
    if (swatch.dataset.secondarySrc) {
      secondaryImg.srcset = swatch.dataset.secondarySrcset || '';
      secondaryImg.src    = swatch.dataset.secondarySrc;
      secondaryImg.hidden = false;
    } else {
      secondaryImg.hidden = true;
    }
  }

  // Update links
  const url = swatch.href;
  if (mediaLink) mediaLink.href = url;
  if (titleLink) titleLink.href = url;

  // Update color label
  if (colorLabel && swatch.dataset.colorLabel) {
    colorLabel.textContent = swatch.dataset.colorLabel;
  }

  // Update price
  if (priceEl && swatch.dataset.priceHtml) {
    priceEl.innerHTML = decodeURIComponent(swatch.dataset.priceHtml.replace(/&amp;/g,'&').replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&quot;/g,'"').replace(/&#39;/g,"'"));
  }

  // Update quick buy drawer handle + variant
  const handle    = swatch.dataset.handle;
  const variantId = swatch.dataset.variantId;
  if (handle && variantId) {
    const drawer = card.querySelector('quick-buy-drawer');
    if (drawer) {
      drawer.setAttribute('handle', `${handle}?variant=${variantId}`);
      // Reset any already-loaded content so it reloads for the new product
      drawer.innerHTML = '';
    }
    // Single-variant quick add form
    const variantInput = card.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = variantId;
  }

  // Update active swatch
  card.querySelectorAll('.sbc-card-swatch').forEach(s => s.classList.remove('is-active'));
  swatch.classList.add('is-active');
});


// Warm a colorway's lead image on hover/touch so the swap is instant.
// Uses the card's own sizes + the swatch srcset, so the browser picks the same
// candidate it will render (one download, not two). Never decode(): that forces
// the full bitmap resident, which is what crashes iOS on image-heavy grids.
(() => {
  const warmed = new WeakSet();
  const WARM_MAX = 12;
  let count = 0;
  const warm = (e) => {
    const swatch = e.target.closest && e.target.closest('.sbc-card-swatch');
    if (!swatch || warmed.has(swatch) || count >= WARM_MAX) return;
    if (swatch.classList.contains('is-active') || !swatch.dataset.primarySrc) return;
    warmed.add(swatch);
    count++;
    const cardImg = swatch.closest('product-card')?.querySelector('.product-card__image--primary');
    const img = new Image();
    if (cardImg && cardImg.sizes) img.sizes = cardImg.sizes;
    img.srcset = swatch.dataset.primarySrcset || '';
    img.src = swatch.dataset.primarySrc;
  };
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);
})();
